document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper(".review-slider", {
    pagination: {
      el: ".swiper-pagination"
    },
    slidesPerView: 1,
    loop: true,
    autoplay: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 10,
      },
    }
  });
});


